import axios from 'axios';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const instance = axios.create({
  baseURL: process.env.REACT_APP_FAST_API,
});

function handleLogut() {
  window.localStorage.clear();
  setTimeout(() => {
    window.location.assign('/login');
  }, 1200);
}

instance.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem('user'));
  const clinics = JSON.parse(localStorage.getItem('clinic'));
  const selectedClinic = JSON.parse(sessionStorage.getItem('selectedClinic'));

  if (token) {
    if (!selectedClinic) {
      const selectedClinicIdx = clinics?.findIndex((s) => s.isActive);
      if (selectedClinicIdx >= 0) {
        sessionStorage.setItem(
          'selectedClinic',
          JSON.stringify(clinics[selectedClinicIdx])
        );
      }
    }
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (axios.isCancel(error) || error.code === 'ERR_CANCELED' || error.message === 'canceled') {
      return Promise.reject(error);
    }

    if (typeof error.response === 'undefined') {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-start',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: 'error',
        title:
          'System sedang dalam perbaikan, silahkan coba beberapa saat lagi',
      });
    }

    if (
      error.response &&
      error.response.status === 401 &&
      error.response?.data?.error?.message ===
        'Sesi anda telah berakhir, silahkan login kembali'
    ) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-start',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: 'error',
        title: 'Sesi Anda Telah Berakhir,Silahkan Login Kembali',
      });
      handleLogut();
    }
    if (
      error.response &&
      error.response.status === 401 &&
      (error.response?.data?.error?.message === 'Anda telah login di tempat lain' ||
        error.response?.data?.error?.message === 'Akun anda tidak terdaftar')
    ) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-start',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.error?.message || 'Anda Telah Login Di Tempat Lain',
      });

      handleLogut();
    }

    return Promise.reject(error);
  }
);

export default instance;
